module.exports = __webpack_public_path__ + "static/media/gg.98f67a6f.svg";